import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../config/api';

const NewsList = () => {
  const [newsList, setNewsList] = useState([]);
  const navigate = useNavigate();

  const filterByauthorId = async (dataArray, author_id) => {
    return dataArray.filter(item => item.author_id === author_id);
  }

  const fetchNews = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/api/news`);

      const userDataRes = await axios.get(`${API_BASE_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const profileData = { ...userDataRes.data, address: { province: userDataRes.data.province, district: userDataRes.data.district, subdistrict: userDataRes.data.subdistrict } };

      //console.log('user', profileData.id);

      //กรองข่าวตามรหัสผู้ใช้
      const newsByAuthor = await filterByauthorId(res.data, profileData.id);
      //console.log('news:', newsByAuthor);

      if (profileData.level === 'ภาค') {
        setNewsList(res.data);
      } else if (profileData.level === 'จังหวัด') {
        setNewsList(newsByAuthor);
      }


    } catch {
      message.error('โหลดข่าวล้มเหลว');
    }
  };

  const deleteNews = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/news/${id}`);
      message.success('ลบข่าวเรียบร้อยแล้ว');
      fetchNews();
    } catch {
      message.error('ไม่สามารถลบข่าวได้');
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const columns = [
    { title: 'หัวข้อข่าว', dataIndex: 'title', key: 'title' },
    { title: 'หมวดหมู่', dataIndex: ['category_name'], key: 'category_name' },
    {
      title: 'การจัดการ',
      key: 'action',
      render: (_, record) => (
        <>
          <Button onClick={() => navigate(`/news-detail/${record.id}`)}>แก้ไข</Button>{' '}
          <Popconfirm
            title="คุณแน่ใจหรือไม่ที่จะลบ?"
            onConfirm={() => deleteNews(record.id)}
          >
            <Button danger>ลบ</Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <Button type="primary" onClick={() => navigate('/news-detail')} style={{ marginBottom: 16 }}>
        เขียนข่าวใหม่
      </Button>
      <Table columns={columns} dataSource={newsList} rowKey="id" />
    </div>
  );
};

export default NewsList;
